import { onMounted, ref } from "vue";
import { getStorageFileUrl, listStorageImageUrls } from "@/services/storageAssets";

export const useStorageFolder = (folderPath, fallbackAssets = []) => {
  const assets = ref([...fallbackAssets]);
  const loading = ref(true);
  const error = ref("");

  const loadAssets = async () => {
    loading.value = true;
    error.value = "";

    if (!folderPath) {
      assets.value = [...fallbackAssets];
      loading.value = false;
      return;
    }

    try {
      const storageAssets = await listStorageImageUrls(folderPath);
      assets.value = storageAssets.length ? storageAssets : [...fallbackAssets];
    } catch (err) {
      assets.value = [...fallbackAssets];
      error.value = err?.message || "Unable to load images from Firebase Storage.";
    } finally {
      loading.value = false;
    }
  };

  onMounted(loadAssets);

  return {
    assets,
    error,
    loading,
    reload: loadAssets,
  };
};

export const useStorageFile = (filePath, fallbackAsset = "") => {
  const assetUrl = ref(fallbackAsset);
  const loading = ref(true);
  const error = ref("");

  const loadAsset = async () => {
    loading.value = true;
    error.value = "";

    if (!filePath) {
      assetUrl.value = fallbackAsset;
      loading.value = false;
      return;
    }

    try {
      assetUrl.value = (await getStorageFileUrl(filePath)) || fallbackAsset;
    } catch (err) {
      assetUrl.value = fallbackAsset;
      error.value = err?.message || "Unable to load image from Firebase Storage.";
    } finally {
      loading.value = false;
    }
  };

  onMounted(loadAsset);

  return {
    assetUrl,
    error,
    loading,
    reload: loadAsset,
  };
};
